import { render, staticRenderFns } from "./DialogOrColumn.vue?vue&type=template&id=78dd466d"
import script from "./DialogOrColumn.vue?vue&type=script&lang=js"
export * from "./DialogOrColumn.vue?vue&type=script&lang=js"
import style0 from "./DialogOrColumn.vue?vue&type=style&index=0&id=78dd466d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports